import { Stack } from "@mui/material";
import Box from "@mui/material/Box";
import { Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import React from "react";
import ButtonBar from "../../components/Buttons/ButtonBar";
import NewButton from "../../components/Buttons/NewButton";
import { Title } from "../../components/Desc";
import ProgressIndicator from "../../components/ProgressIndicator";
import BasicMenu from "../../components/menu/BasicMenu";
import strings from "../../config/localization";
import { useGetOrganizationsQuery } from "../../services/appln";
import { doesPermissionExist } from "../util";
import DeleteOrganization from "./DeleteOrganization";
import EditOrganization from "./EditOrganization";
import NewOrganization from "./NewOrganization";

interface Organization {
  id: string;
  name: string;
  parentName: string;
}

export default function ListOrganizations() {
  const [newDialogOpen, setNewDialogOpen] = React.useState(false);
  const queryResponse = useGetOrganizationsQuery("");

  const columns: ColumnsType<Organization> = [
    {
      title: strings.name,
      dataIndex: "name",
      key: "name",
    },
    {
      title: strings.parentOrg,
      dataIndex: "parentName",
      key: "parentName",
    },
  ];

  if (doesPermissionExist("delete-org") || doesPermissionExist("update-org")) {
    columns.push({
      title: "",
      dataIndex: "menu",
      key: "menu",
      render: (text, record, index) => {
        const options = [
          [
            null,
            <Stack direction={"column"} spacing={1}>
              {doesPermissionExist("update-org") && (
                <EditOrganization id={record.id} initialValues={record} />
              )}
              {doesPermissionExist("delete-org") && (
                <DeleteOrganization id={record.id} />
              )}
            </Stack>,
            null,
            "designations",
            "action",
          ],
        ];
        return (
          <BasicMenu
            action={strings.actions}
            options={options}
            data={record}
            type="location"
          />
        );
      },
    });
  }

  return (
    <div>
      <Box sx={{ height: 400, width: "100%" }}>
        <Stack spacing={2} style={{ alignItems: "flex-start" }}>
          <Title text={strings.organizations} />
          {(queryResponse.isLoading || queryResponse.isFetching) && (
            <ProgressIndicator />
          )}
          {doesPermissionExist("create-org") && (
            <ButtonBar>
              <NewButton
                onClickHandler={() => {
                  setNewDialogOpen(true);
                }}
              />
              <NewOrganization
                onSubmitHandler={(newObj: any) => {
                  setNewDialogOpen(false);
                }}
                onCancelHandler={() => {
                  setNewDialogOpen(false);
                }}
                state={newDialogOpen}
              />
            </ButtonBar>
          )}
          <Table
            virtual
            scroll={{ y: 600 }}
            columns={columns}
            dataSource={queryResponse.data?.data}
            pagination={false}
            rowKey="id"
          />
        </Stack>
      </Box>
    </div>
  );
}
